import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { HowItWorks } from './pages/HowItWorks';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rkdwustqp9n8">
      <Layout data-id="element-1" data-mp="2rlynw8guiagc">
        <Routes data-id="element-2" data-mp="2rlf5yrr73m2b">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mm2mmgzj8x4h" />} data-id="element-3" data-mp="2rit2p4bc7spw" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-6" data-mp="2mnnhk7prei2v" />} data-id="element-5" data-mp="2mmltn2nna13q" />
          <Route path="/services" element={<Services data-id="element-8" data-mp="31ayr642drs0c" />} data-id="element-7" data-mp="2mjzp7bw1w1pq" />
          <Route path="/about" element={<About data-id="element-10" data-mp="31ctaxf1x1e2u" />} data-id="element-9" data-mp="31bi8bik7icdb" />
          <Route path="/contact" element={<Contact data-id="element-12" data-mp="2wiywor52xrb5" />} data-id="element-11" data-mp="2wka1mua9h53u" />
          <Route path="*" element={<NotFound data-id="element-14" data-mp="2wi5mfg6wwjo9" />} data-id="element-13" data-mp="2wip5x1c7ng4e" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}